import { connect } from 'react-redux';
import Checklists from './checklists';

import {
  onLoadChecklists,
  onExportChecklistContent,
  pinOrUnpinContentAction,
  selectChecklist,
  onStartChecklist,
  onLoadChecklistDueDates,
  selectChecklistRun,
} from '../../reducers/checklist.reducers';
import { navigate } from '../../reducers/navigator.reducers';
import { onLoadChecklistItemGroups } from '../../reducers/checklistItemGroup.reducers';
const mapStateToProps = (state) => ({
  isLoading: state.checklist.isLoading,
  checklists: state.checklist.checklists,
  bulletinBoard: state.checklist.bulletinBoard,
  checklistRuns: state.checklist.checklistRuns,
  checklistDueDates: state.checklist.checklistDueDates,
  dueChecklists: state.checklist.dueChecklists,
});

const mapDispatchToProps = (dispatch) => ({
  startNewChecklistRun: (checklist) => {
    dispatch(onStartChecklist({ checklistId: checklist.id }));
  },
  selectChecklist: (checklist) => dispatch(selectChecklist(checklist)),
  selectChecklistRun: (checklist, checklistRun) =>
    dispatch(selectChecklistRun(checklist, checklistRun)),
  onLoadChecklistDueDates: () => dispatch(onLoadChecklistDueDates()),
  onLoadChecklists: () => dispatch(onLoadChecklists()),
  navigate: (route) => dispatch(navigate({ route })),
  onExportChecklistContent: (url) => dispatch(onExportChecklistContent(url)),
  pinOrUnpinContent: (bulletinBoardId, pinningDto) =>
    dispatch(pinOrUnpinContentAction({ bulletinBoardId, pinningDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checklists);



// WEBPACK FOOTER //
// ./src/app/main/checklists/checklists.container.js